module.exports = __webpack_public_path__ + "public/img/防火巡查Bg.1a591dfb.png";